<div class="legend">
	<div class="legend-item" *ngFor="let legendItem of legends; let index = index">
		<div class="legend-box" [style.background]="getLegendColor(index)"></div>
		<div class="legend-text">{{ legendItem }}</div>
	</div>
</div>
